import { guideValidate } from '../../application/dtos/guide_validate'

export class guideEntity {
    constructor({id, customer, shipping_service, account, guide, date, weight, packing, volumetric_weight, insurance_amount, origin, destination, zone, extended_zone, status, guide_charge}){
        this.id = id;
        this.customer = customer;
        this.shipping_service = shipping_service;
        this.account = account;
        this.guide = guide;
        this.date = date;
        this.weight = weight;
        this.packing = packing;
        this.volumetric_weight = volumetric_weight;
        this.insurance_amount = insurance_amount;
        this.origin = origin;
        this.destination = destination
        this.zone = zone;
        this.extended_zone = extended_zone;
        this.status = status;
        this.guide_charge = guide_charge;
        this.has_return = status.some(obj => obj.status === "Returning package to shipper")
    }

    isValid() {
        return guideValidate(this);
    }
}